<template>
    <div>
        <div class="async-mapping-adder">
            <div class="async-select-with-title">
                <h2>{{ jiraSelectTitle }}</h2>
                <UserSelect 
                    v-model="selectedJiraValue"
                    class="mapping-input-select"
                    :options="jiraValues"
                    :is-fetching="isFetchingJiraValue"
                    :async="true"
                    @search-change="onGetJiraValues"
                />
            </div>
            
            <Button :disabled="isMapButtonDisabled" @click="addMapping()" class="map-button">Map</Button>
            
            <div class="async-select-with-title">
                <h2>{{ tfsSelectTitle }}</h2>
                <UserSelect
                    v-model="selectedTfsValue"
                    class="mapping-input-select"
                    :options="tfsValues"
                    :useCustomFiltering="true"
                />
            </div>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import { NAMESPACE as MAPPINGS_NAMESPACE } from '../../store/modules/mappings.js';
import { Button } from '@spartez/vue-atlaskit';
import UserSelect from './UserSelect.vue';
import pDebounce from 'p-debounce';

const debounceTimeMs = 300;

export default {
    props: {
        jiraSelectTitle: String, 
        tfsSelectTitle: String
    },
    data() {
        return {
            selectedTfsValue: null,
            selectedJiraValue: null,
            isFetchingJiraValue: false,
        }
    },
    components: {
        UserSelect,
        Button
    },
    computed: {
        ...mapGetters({
            jiraValues: MAPPINGS_NAMESPACE.getters.JIRA_VALUES,
            tfsValues: MAPPINGS_NAMESPACE.getters.TFS_VALUES,
        }),
        isMapButtonDisabled() {
            return !this.selectedJiraValue || !this.selectedTfsValue;
        },
    },
    created() {
        this.onGetJiraValues = pDebounce(this.onGetJiraValues, debounceTimeMs);
    },
    methods: {
        ...mapActions({
            mapValues: MAPPINGS_NAMESPACE.actions.MAP,
            getJiraValues: MAPPINGS_NAMESPACE.actions.GET_JIRA_VALUES,
        }),
        addMapping() {
            if (this.selectedJiraValue !== null && this.selectedTfsValue !== null) {
                let pair = {
                    jiraValue: this.selectedJiraValue,
                    tfsValue: this.selectedTfsValue
                };
                this.mapValues(pair);
                this.selectedTfsValue = null;
                this.selectedJiraValue = null;
            }
        },
        async onGetJiraValues(query) {
            if(query === "") return;
            this.isFetchingJiraValue = true;
            await this.getJiraValues({ query, filterMappedValues: true });
            this.isFetchingJiraValue = false;
        },
    }
}
</script>

<style scoped>
.async-mapping-adder{
    display: flex;
    justify-content: space-between;
    align-content: flex-end;
}

.async-select-with-title{
    width: 45%;
}

.async-select-with-title h2{
    text-align: left;
    margin-bottom: 11px;
}

.map-button{
    align-self: flex-end;
    margin: 4px;
}
</style>


// WEBPACK FOOTER //
// src/components/users/UsersMappingAdder.vue